import { forwardRef, type ComponentPropsWithoutRef } from 'react'

import { Button } from '@runtime/components/ui/Button'
import { FormField } from '@runtime/components/ui/Form'
import styles from '@runtime/components/layout/PageLayout.module.scss'

type PageVariant = 'menu' | 'hub'

type PageProps = {
  variant?: PageVariant
  className?: string
} & Omit<ComponentPropsWithoutRef<'div'>, 'className'>

export const Page = forwardRef<HTMLDivElement, PageProps>(function Page(
  { variant, className, ...props },
  ref,
) {
  const classes = [
    'page',
    styles.page,
    variant === 'menu' ? 'menu-page' : '',
    variant === 'hub' ? 'hub-page' : '',
    variant === 'menu' ? styles.menuPage : '',
    variant === 'hub' ? styles.hubPage : '',
    className || '',
  ]
    .filter(Boolean)
    .join(' ')
  return <div ref={ref} className={classes} {...props} />
})

type FixedColProps = ComponentPropsWithoutRef<'div'>

export function FixedCol({ className, ...props }: FixedColProps) {
  const classes = ['fixed-col', styles.fixedCol, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

type TopbarProps = ComponentPropsWithoutRef<'div'>

export function Topbar({ className, ...props }: TopbarProps) {
  const classes = ['topbar', styles.topbar, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

type TopbarTitleProps = ComponentPropsWithoutRef<'div'>

export function TopbarTitle({ className, ...props }: TopbarTitleProps) {
  const classes = ['topbar-title', styles.topbarTitle, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

type TitleCenterProps = ComponentPropsWithoutRef<'div'>

export function TitleCenter({ className, ...props }: TitleCenterProps) {
  const classes = ['title-center', styles.titleCenter, className || '']
    .filter(Boolean)
    .join(' ')
  return <div className={classes} {...props} />
}

export function HubTitle({ className, ...props }: TitleCenterProps) {
  const classes = ['hub-title', styles.hubTitle, className || '']
    .filter(Boolean)
    .join(' ')
  return <TitleCenter className={classes} {...props} />
}

type TopbarHelpButtonProps = ComponentPropsWithoutRef<'button'>

export function TopbarHelpButton({
  className,
  type,
  ...props
}: TopbarHelpButtonProps) {
  const classes = ['topbar-help-btn', styles.topbarHelpBtn, className || '']
    .filter(Boolean)
    .join(' ')
  return (
    <Button
      size="s"
      variant="ghost"
      className={classes}
      type={type || 'button'}
      {...props}
    />
  )
}

type TopbarSelectProps = ComponentPropsWithoutRef<'select'> & {
  className?: string
}

export function TopbarSelect({ className, ...props }: TopbarSelectProps) {
  const classes = [styles.topbarField, styles.topbarSelect, className || '']
    .filter(Boolean)
    .join(' ')
  return <FormField as="select" className={classes} {...props} />
}
